import React from 'react'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import Breadcrumb from '../../../components/breadcrumb'

const ContactUsHeader = () => {
    const styles = useMultiStyleConfig('ContactUs')

    const categories = [
        {
            id: 1,
            name: (
                <FormattedMessage
                    id="login_form.message.back_to_homepage"
                    defaultMessage="Back to Homepage"
                />
            ),
        },
        {
            id: 2,
            name: <FormattedMessage id="contact_us.header_title" defaultMessage="Contact Us" />,
        },
    ]

    return (
        <Flex {...styles.titleContainer}>
            <Breadcrumb homepage={true} {...styles.breadcrumb} categories={categories}></Breadcrumb>
            <Box {...styles.titleSection}>
                <Text {...styles.title}>
                    <FormattedMessage id="contact_us.header_title" defaultMessage="Contact Us" />
                </Text>
            </Box>
        </Flex>
    )
}

export default ContactUsHeader
